import React from 'react';
import { useTranslation } from 'react-i18next';
import { DriverActivityAdminStatus } from '../graphql/types';
import { STATUS_TAG_STYLE, STATUS_TEXT_COLOR } from '../utils/activityFormUtils';

/** 页头状态胶囊（原型 .tag） */
export const ActivityStatusTag: React.FC<{ status: DriverActivityAdminStatus }> = ({ status }) => {
    const { t } = useTranslation();
    const style = STATUS_TAG_STYLE[status] ?? STATUS_TAG_STYLE[DriverActivityAdminStatus.DRAFT];
    return (
        <span className="inline-block text-[13px] font-semibold rounded px-2 py-[2px] leading-5" style={style}>
            {t(`driverOps.activity.status.${status}`, { defaultValue: status })}
        </span>
    );
};

/** 列表状态列：纯色加粗文字（原型 .st），不是胶囊 */
export const ActivityStatusText: React.FC<{ status: DriverActivityAdminStatus }> = ({ status }) => {
    const { t } = useTranslation();
    return (
        <span className="font-semibold" style={{ color: STATUS_TEXT_COLOR[status] ?? '#8C8C8C' }}>
            {t(`driverOps.activity.status.${status}`, { defaultValue: status })}
        </span>
    );
};
